//relies on translations, language variable from PouchService
import { Pipe, PipeTransform } from '@angular/core';
import { PouchService } from '../services/pouch-service';
@Pipe({
  name: 'FaTranslate',
})
export class FaIcon implements PipeTransform {
  constructor() {
  }
  transform(icon) {
    return (icon.replace('fa-', ''));
  }
}
